import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createSlots as _createSlots, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "login-layout__subtitle" }
const _hoisted_4 = { class: "login-layout__footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButton = _resolveComponent("BackButton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_HeaderTitle = _resolveComponent("HeaderTitle")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_NonAuthenticatedFooter = _resolveComponent("NonAuthenticatedFooter")!
  const _component_FullCenterLayout = _resolveComponent("FullCenterLayout")!

  return (_openBlock(), _createBlock(_component_FullCenterLayout, { class: "login-layout" }, {
    default: _withCtx(() => [
      _createVNode(_component_a_row, {
        justify: "center",
        class: "login-layout__form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            sm: 6,
            class: _normalizeClass([
          'login-layout__form__header',
          _ctx.showLogoutButton && 'login-layout__form__header--with-logout',
        ])
          }, {
            default: _withCtx(() => [
              (_ctx.showLogo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "login-layout__logo",
                    src: _ctx.Logo,
                    alt: _ctx.t('{merchantBrand}', { merchantBrand: _ctx.merchantBrand })
                  }, null, 8, _hoisted_1))
                : _createCommentVNode("", true),
              (_ctx.showLogoutButton)
                ? (_openBlock(), _createBlock(_component_BackButton, {
                    key: 1,
                    onOnBackClick: _ctx.logoutUser,
                    label: _ctx.t('Log out'),
                    loading: _ctx.logoutLoading,
                    "mobile-text-only": ""
                  }, null, 8, ["onOnBackClick", "label", "loading"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_a_col, { xs: 24 }, {
            default: _withCtx(() => [
              (_ctx.title || _ctx.subtitle)
                ? (_openBlock(), _createBlock(_component_HeaderTitle, {
                    key: 0,
                    class: "mb-30"
                  }, _createSlots({
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        (_ctx.showBackButton)
                          ? (_openBlock(), _createBlock(_component_BackButton, {
                              key: 0,
                              showBtnText: false,
                              onOnBackClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('goBack')))
                            }))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.title), 1)
                      ])
                    ]),
                    _: 2
                  }, [
                    (_ctx.subtitle)
                      ? {
                          name: "subtitle",
                          fn: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.subtitle), 1)
                          ]),
                          key: "0"
                        }
                      : undefined
                  ]), 1024))
                : _createCommentVNode("", true),
              _renderSlot(_ctx.$slots, "login-alerts", {}, () => [
                (_ctx.errorMessage)
                  ? (_openBlock(), _createBlock(_component_a_alert, {
                      key: 0,
                      type: "error",
                      message: _ctx.errorMessage
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true)
              ]),
              _renderSlot(_ctx.$slots, "body")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_NonAuthenticatedFooter)
      ])
    ]),
    _: 3
  }))
}